import * as React from "react";
const SvgMinus24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 2,
        fill: "black",
        viewBox: "0 0 14 2"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M14 2H0V0h14v2Z",
      clipRule: "evenodd"
    })
  );
export default SvgMinus24Px;
